module.exports = __webpack_public_path__ + "5a6a112536159346b3f132df84b7b32b.woff";